import React from "react"
import { AnalyticsThemeProvider } from "@app"

import overrideComponents from "./overrides"
import { dsColorNew, rentacarPalette } from "./palette"
import { toastGlobalStyles } from "./toasts"
import { fieldGlobalStyles } from "./fields"

export default function AppTheme({ children }) {
	return <AnalyticsThemeProvider
		global={{
			// amCharts' "no data" modal ships at z-index 100000 and covered the fixed header
			'.am5-modal': { zIndex: '1 !important' },
			// …and its white popup reads as the app's muted empty line, inside the chart's card
			'.am5-modal-content': {
				background: 'transparent !important', boxShadow: 'none !important', border: 'none !important',
				color: `${dsColorNew.textMuted} !important`, fontSize: '13px !important', fontFamily: 'Roboto, sans-serif',
			},
			'.am5-modal-curtain': { background: 'transparent !important' },
			// The AI chat bubble sits bottom right: while a side drawer is open it rises above the
			// drawer's footer, so it never covers Save
			'body:has(.MuiDrawer-root.MuiModal-root:not(.MuiModal-hidden)) .dsb-btn': { bottom: '84px !important' },
			...toastGlobalStyles,
			...fieldGlobalStyles,
		}}
		overrides={overrideComponents}
		palette={rentacarPalette}>
		{children}
	</AnalyticsThemeProvider>
}

